import styled from 'styled-components';

import { colors } from '@/globalStyles';
import { isWebComponentEnvironment } from '@/helpers';
import { getConfig } from '@/config/runtimeConfig';

const webComponent = isWebComponentEnvironment();
// In the web-component build the editor is normally capped at 768px tall; the runtime
// `UNCONSTRAINED_HEIGHT` flag lifts the cap to fill the viewport. This used to key off a hardcoded
// dev host/IP (`localhost` / `52.29.124.211`). Evaluated at render time so loaded config applies.
const withoutFixedHeight = () => webComponent && getConfig().unconstrainedHeight;

export const PageWrapperStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 90px 10px 1fr;
  width: 100%;
  height: 100%;
  min-height: ${() => (webComponent ? '768px' : '100%')};
  max-height: ${() => (withoutFixedHeight() ? '100%' : '768px')};
  background-color: ${colors.white};
  overflow: auto;
  font-family: Lato;
`;

export const BodyStyled = styled.div`
  min-width: 1280px;
  display: grid;
  grid-template-columns: 1fr 10px 450px;
  background-color: ${colors.backgroundBody};
  overflow: hidden;
`;

export const CanvasStyled = styled.div`
  background-color: ${colors.white};
`;

export const OptionPanelWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
  overflow: hidden;
  z-index: 1;
`;

export const FloatableSectionContentTextareaStyled = styled.div`
  position: fixed;
`;
